module.exports = __webpack_public_path__ + "static/media/client_xs_0.1c83ad1a.png";